export const DASHBOARD = 'Dashboard - Simplified Society Management App';
export const LOGIN = 'SocietyXpert - Simplified Society Management App';
export const BANK_DETAILS_SETUP = 'Bank Details Setup - Simplified Society Management App';